<div class="top-action">
  Already have an account?
  <a class="link" (click)="!loading() && showSignIn()">Sign In</a>
</div>
<div class="form" [class.loading]="loading()">
  @if (loading()) {
    <div class="loading-overlay">
      <app-loading-spinner/>
    </div>
  }
  <div class="title">
    <p>Create Sporty's Account</p>
  </div>
  <div class="horizontal-separator"></div>
  <form [formGroup]="form()" autocomplete="off">
    <div class="f-row">
      <div class="f-group">
        <label>First Name*</label>
        <input
          formControlName="firstName"
          placeholder="Enter first name"
          class="f-control"
          type="text"
          [class.error]="
            form() &&
            form().get('firstName').touched &&
            form().get('firstName').invalid
          "
        />
      </div>
      <div class="f-group">
        <label>Last Name*</label>
        <input
          formControlName="lastName"
          placeholder="Enter last name"
          class="f-control"
          type="text"
          [class.error]="
            form() &&
            form().get('lastName').touched &&
            form().get('lastName').invalid
          "
        />
      </div>
    </div>
    <div class="f-row">
      <div class="f-group">
        <label>Email*</label>
        <input
          formControlName="email"
          placeholder="Enter your email address"
          class="f-control"
          type="text"
          [class.error]="
            form() &&
            form().get('email').touched &&
            form().get('email').invalid
          "
        />
      </div>
    </div>
    <div class="f-row">
      <div class="f-group">
        <label>Confirm Email*</label>
        <input
          formControlName="confirmEmail"
          placeholder="Confirm your email address"
          class="f-control"
          type="text"
          [class.error]="
            form() &&
            form().get('confirmEmail').touched &&
            (form().get('confirmEmail').invalid ||
            form().errors?.emailMismatch)
          "
        />
      </div>
    </div>
    <div class="f-row f-row-vertical">
      <div class="f-group">
        <label>Password*</label>
        <input
          formControlName="password"
          placeholder="Enter your password"
          class="f-control"
          autocomplete="new-password"
          [type]="passwordVisible() ? 'text' : 'password'"
          [class.error]="
            form() &&
            form().get('password').touched &&
            form().get('password').invalid
          "
        />
        <div class="icon-suffix" (click)="togglePasswordVisibility()">
          @if (passwordVisible()) {
            <i class="fa fa-eye"></i>
          } @else {
            <i class="fa fa-eye-slash"></i>
          }
        </div>
      </div>
      <div
        class="f-info first"
        [class.error]="
          form() &&
          form().get('password').touched &&
          form().get('password').invalid
        "
      >
        Must contain one upper case letter, one lower case letter and one number
      </div>
      <div
        class="f-info second"
        [class.error]="
          form() &&
          form().get('password').touched &&
          form().get('password').invalid
        "
      >
        Minimum length of 8 characters
      </div>
    </div>
  </form>
  @if (error()) {
    <div class="message error">
      {{ error() }}
    </div>
  }
</div>
